import { render, staticRenderFns } from "./booking-days-table.vue?vue&type=template&id=d4957418&scoped=true&"
import script from "./booking-days-table.vue?vue&type=script&lang=js&"
export * from "./booking-days-table.vue?vue&type=script&lang=js&"
import style0 from "./booking-days-table.vue?vue&type=style&index=0&id=d4957418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4957418",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VSimpleTable,VTabItem})
